import * as React from "react"
import UniversalLink from "§/src/utils/UniversalLink"
import { sanitize } from '§/src/utils/functions';

// Language
 import { useTranslation } from 'react-i18next';

/**
 * Internal dependencies.
 */
import "./_breadcrumb.scss"

const Breadcrumb = props => {
  const { t } = useTranslation();
  // set atom class
  const atomClassName = "breadcrumb"
  var atomClass =
    props.className !== undefined
      ? atomClassName + " " + props.className
      : atomClassName

  return (
    <nav className={atomClass} aria-label="breadcrumb">
      <ol className="breadcrumb">
        {props?.wpseo &&
          props.wpseo.map((crumb, index) => {
            // console.log('test', props.wpseo.length)
            const crumbLink = index === 0 ? "/" : crumb.url

            // Current page
            if (props.wpseo.length - 1 === index) {
              return (
                <li
                  key={index}
                  className="breadcrumb-item active"
                  dangerouslySetInnerHTML={{ __html: sanitize(crumb.text.replace(/&amp;/g, '&')) }}
                />
              )

              // props.base -> custom item prefix
            } else if (index === 1) {
              return (
                <li key={index} className="breadcrumb-item">
                  <UniversalLink to={crumbLink}>{t('Prodotti')}</UniversalLink>
                </li>
              )

              // normal
            } else {
              return (
                <li key={index} className="breadcrumb-item">
                  <UniversalLink to={crumbLink}>{crumb.text.replace(/&amp;/g, '&')}</UniversalLink>
                </li>
              )
            }
          })}
      </ol>
    </nav>
  )
}

export default Breadcrumb
